<template>
  <div style="height: 100%">
    <apex-chart
      ref="apexCharts"
      v-if="series"
      height="100%"
      :options="options"
      :series="series"
    ></apex-chart>
  </div>
</template>

<script>
  import apexChart from "@/components/wrappers/apexCharts/apexChart.vue";

  export default {
    components: {
      apexChart,
    },
    props: {
      series: [],
    },
    computed: {
      options: function () {
        return {
          colors: ["#ff5e16", "#06163a", "#4aa13f"],

          chart: {
            type: "bar",
          },
          plotOptions: {
            bar: {
              horizontal: this.$q.screen.lt.sm,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          xaxis: {
            categories: [],
            labels: {
              maxHeight: 180,
            },
          },
          yaxis: {
            title: {
              text: "Count p/h",
            },
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        };
      },
    },
    watch: {},
    data: () => ({
      chartLoaded: true,
    }),
    methods: {},
    beforeDestroy: function () {},
    mounted() {},
  };
</script>
